import React, { createContext, useState, useContext } from 'react';

// Create the context
const UrlThankYouMessageContext = createContext();

// Create a provider component
export const UrlThankYouMessageProvider = ({ children }) => {
    const [urlThankYouMessage, setUrlThankYouMessage] = useState('');

    return (
        <UrlThankYouMessageContext.Provider value={{ urlThankYouMessage, setUrlThankYouMessage }}>
            {children}
        </UrlThankYouMessageContext.Provider>
    );
};

// Custom hook to use the UrlThankYouMessageContext
export const useUrlThankYouMessage = () => {
    return useContext(UrlThankYouMessageContext);
};
